// panels/BarPanel.jsx
import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
  CartesianGrid, Cell, Legend,
} from 'recharts';
import { PanelWrapper } from './PanelWrapper';

const SOURCE_COLORS = {
  GCP:      '#4285f4',
  AZURE:    '#0078d4',
  MONGODB:  '#4ade80',
  DATABASE: '#a78bfa',
};

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  const total  = payload.find(p => p.dataKey === 'total')?.value  || 0;
  const errors = payload.find(p => p.dataKey === 'errors')?.value || 0;
  return (
    <div style={{
      background: 'var(--bg-card)', border: '1px solid var(--border)',
      borderRadius: 8, padding: '8px 12px', fontSize: 11,
    }}>
      <div style={{ fontWeight: 600, marginBottom: 4, color: SOURCE_COLORS[label] || 'var(--text)' }}>{label}</div>
      <div style={{ color: '#3b82f6' }}>Total: {total.toLocaleString()}</div>
      <div style={{ color: '#ef4444' }}>Errors: {errors.toLocaleString()}</div>
      {total > 0 && <div style={{ color: 'var(--text-3)' }}>Error rate: {((errors / total) * 100).toFixed(1)}%</div>}
    </div>
  );
}

export function BarPanel({ data = [], loading, title = 'Log Volume by Source' }) {
  const chartData = data.map(d => ({
    source: d._id || d.source,
    total:  d.total || d.count || 0,
    errors: d.errors || 0,
    warns:  d.warns  || 0,
  }));

  return (
    <PanelWrapper title={title} datasource="MongoDB" loading={loading}>
      <div style={{ padding: '12px 4px 8px 0', height: 200 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData} margin={{ top: 4, right: 16, left: 0, bottom: 0 }}>
            <CartesianGrid stroke="rgba(255,255,255,.04)" strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="source" tick={{ fill: '#64748b', fontSize: 11 }} axisLine={false} tickLine={false} />
            <YAxis
              tick={{ fill: '#64748b', fontSize: 10 }} axisLine={false} tickLine={false} width={42}
              tickFormatter={v => v >= 1000 ? `${(v / 1000).toFixed(0)}k` : v}
            />
            <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(255,255,255,0.03)' }} />
            <Legend
              wrapperStyle={{ fontSize: 11, paddingTop: 4 }}
              formatter={val => <span style={{ color: 'var(--text-2)' }}>{val}</span>}
            />
            <Bar dataKey="total" name="Total" radius={[3, 3, 0, 0]} maxBarSize={40}>
              {chartData.map((d, i) => (
                <Cell key={i} fill={SOURCE_COLORS[d.source] || '#64748b'} fillOpacity={0.85} />
              ))}
            </Bar>
            <Bar dataKey="errors" name="Errors" fill="#ef4444" fillOpacity={0.7} radius={[3, 3, 0, 0]} maxBarSize={40} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </PanelWrapper>
  );
}
